import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RegisterAusdruckType, VerfahrenFacade } from '@schir-int-client/verfahren-shared';
import { SpaltenName } from '../../../register-shared/src/lib/register.model';
import {
	addChangeEntryAction,
	addEntryBatchAction,
	addVermerkEntryAction,
	createUmschreibungEntryAction,
	deleteEntryAction,
	refreshStateAction,
	updateChangeEntryAction,
} from './register-change.actions';
import {
	BatchEntry,
	ChangeEntry,
	ChangeEntryResource,
	ChangeEntryVermerk,
	ChangeEntryVermerkResource,
} from './register-change.model';
import { RegisterFeatureState } from './register-change.selectors';

@Injectable({ providedIn: 'root' })
export class RegisterBlattChangeFacade {
	constructor(
		private store: Store<RegisterFeatureState>,
		private verfahrenFacade: VerfahrenFacade
	) {}

	addChangeEntry(changeEntry: ChangeEntry) {
		this.store.dispatch(addChangeEntryAction({ changeEntry }));
	}

	addVermerk(spaltenName: SpaltenName, vermerk: string): void {
		const changeEntryVermerk: ChangeEntryVermerk = {
			spaltenName,
			freigabeText: null,
			positionInSpalte: null,
			spaltenWert: {
				vermerk,
			},
		};
		this.store.dispatch(addVermerkEntryAction({ changeEntryVermerk }));
	}

	createUmschreibungEntry(changeEntryResource: ChangeEntryResource, newChangeEntry: ChangeEntry) {
		this.store.dispatch(createUmschreibungEntryAction({ changeEntryResource, newChangeEntry }));
	}

	deleteEntry(changeEntry: ChangeEntryResource) {
		this.store.dispatch(deleteEntryAction({ changeEntry }));
	}

	editVermerk(vermerk: ChangeEntryVermerkResource) {
		this.updateChangeEntry(vermerk);
	}

	updateChangeEntry(changeEntry: ChangeEntryResource) {
		this.store.dispatch(updateChangeEntryAction({ changeEntry }));
	}

	downloadAusdruck(type: RegisterAusdruckType) {
		this.verfahrenFacade.downloadAusdruck(type);
	}

	refreshState() {
		this.store.dispatch(refreshStateAction());
	}

	addBatch(batchEntries: BatchEntry[]) {
		this.store.dispatch(addEntryBatchAction({ batchEntries }));
	}
}
